import SAVE_INVOICE from './saveInvoice.gql';

export default SAVE_INVOICE;
export { SAVE_INVOICE };
